import React from 'react';
import { motion } from 'framer-motion';
import { useArchiveDashboard } from '../../components/archive/hooks/useArchiveDashboard';
import ArchiveStatsCards from '../../components/archive/ArchiveStatsCards';
import ArchiveCharts from '../../components/archive/ArchiveCharts';
import ArchiveQuickActions from '../../components/archive/ArchiveQuickActions';
import RecentDocuments from '../../components/archive/RecentDocuments';
import { containerVariants, itemVariants } from '../../utils/animations';

export default function ArchiveDashboard() {
  const { stats, loading } = useArchiveDashboard();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin w-8 h-8 border-4 border-purple-500 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <motion.div
      className="space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* Header */}
      <motion.div variants={itemVariants}>
        <h1 className="text-2xl md:text-3xl font-bold">Dashboard Arsip Terintegrasi</h1>
        <p className="text-gray-500 mt-1">
          Centralized Document Management System untuk seluruh modul PRIMA
        </p>
      </motion.div>

      {/* Stats Cards */}
      <motion.div variants={itemVariants}>
        <ArchiveStatsCards
          totalDocuments={stats.totalDocuments}
          validDocuments={stats.validDocuments}
          pendingValidation={stats.pendingValidation}
          expiredDocuments={stats.expiredDocuments}
        />
      </motion.div>

      {/* Charts */}
      <motion.div variants={itemVariants}>
        <ArchiveCharts byModule={stats.byModule} byStatus={stats.byStatus} />
      </motion.div>

      {/* Quick Actions */}
      <motion.div variants={itemVariants}>
        <ArchiveQuickActions />
      </motion.div>

      {/* Recent Documents */}
      <motion.div variants={itemVariants}>
        <RecentDocuments documents={stats.recentDocuments} />
      </motion.div>
    </motion.div>
  );
}
